/* eslint-disable @typescript-eslint/no-explicit-any -- AG Grid renderer params, as before the move */
import type { CSSProperties } from "react";

/** Fills AG Grid cell vertical space (pipeline rows use stretch + flex) */
const cellShell: CSSProperties = {
  height: "100%",
  width: "100%",
  minHeight: 0,
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
};

export const ProbabilityBarRenderer = (params: any) => {
  const raw = params.value;
  if (raw == null || raw === "") {
    return null;
  }
  const primitive =
    raw !== null && typeof raw === "object" && "id" in raw ? raw.id : raw;
  const value = Number(primitive);
  if (!Number.isFinite(value) || value === 0) {
    return null;
  }

  const getColor = () => {
    if (value < 50) return "#f44336";
    if (value < 75) return "#ff9800";
    if (value === 100) return "#1B7A63";
    return "#4caf50";
  };

  return (
    <div
      style={{
        ...cellShell,
        position: "relative",
        lineHeight: 1,
        fontSize: 12,
        height: "80%",
      }}
    >
      {/* Bar */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: `${value}%`,
          backgroundColor: getColor(),
          opacity: 0.25,
          borderRadius: 2,
        }}
      />

      {/* Text */}
      <span style={{ position: "relative", paddingLeft: 4 }}>{value}%</span>
    </div>
  );
};

export const PriorityRenderer = (params: any) => {
  const raw = params.value;
  const value =
    raw !== null && typeof raw === "object" && "id" in raw ? raw.id : raw;

  const getColor = () => {
    switch (value) {
      case "High":
        return "#4caf50";
      case "Medium":
        return "#ffb300"; // amber
      case "Low":
        return "#f44336";
      default:
        return "transparent";
    }
  };

  const color = getColor();

  return (
    <div
      style={{
        ...cellShell,
        gap: 4,
        lineHeight: 1,
        fontSize: 12,
      }}
    >
      <span>{value}</span>

      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
    </div>
  );
};
